require('/src/com/yext/listingslaunchstorm/js/components/styles/matchresults.module.scss.module.css');

export const cardTitle = "_card-title_1u3ib_1";
export const cardDescription = "_card-description_1u3ib_1";
export const input = "_input_1u3ib_1";
export const invalidStoreCodeText = "_invalid-store-code-text_1u3ib_1";
export const smallViewportSupport = "_small-viewport-support_1u3ib_1";
export const successStoreCodeText = "_success-store-code-text_1u3ib_1";
export const matchesLoadingDisclaimer = "_matches-loading-disclaimer_1u3ib_1";
export const disabledMatchesCallout = "_disabled-matches-callout_1u3ib_1";
export const matchCard = "_match-card_1u3ib_1";
export const currentMatchTooltip = "_current-match-tooltip_1u3ib_1";
export const dropdownSummary = "_dropdown-summary_1u3ib_1";
export const alternativeMatchOptions = "_alternative-match-options_1u3ib_1";
